define(['jquery', 'availabilityForm'], function($, availabilityForm) {
    var AJAX_URL = '/wp-admin/admin-ajax.php';
    var rooms;
    var render = function($container, params, cb) {
        $('.loader').removeClass('hidden');
        var request = Object.assign({ action: 'get_offers' }, availabilityForm.get());

        if (params) {
            request = Object.assign(request, params);
        }

        //show direct offer code (one time only)
        if (availabilityForm.getDirectOfferCode() !== '') {
            request.rate_plan = availabilityForm.getDirectOfferCode().toUpperCase();
            availabilityForm.clearDirectOfferCode();
        }

        $.post(AJAX_URL, request)
            .done(function(response) {
                $container.html(response);
                bindSelectRoomButtons($container);

                if ($.isFunction(cb)) {
                    cb();
                }
            })
            .fail(function() {
                console.log('Offer request error', request);
            })
            .always(function() {
                $('.loader').addClass('hidden');
            });
    };

    var bindSelectRoomButtons = function($container) {
        $('[data-action="offer-select-room"]').click(function() {
            var $roomContainer = $('.offer-ajax', $(this).closest('.item'));
            var ratePlan = $(this).data('code');
            var promoCodeInUse = ($('[name="promo_code"]').val() !== '');
            var isOffer = !promoCodeInUse;

            rooms.render($roomContainer, { rate_plan: ratePlan, is_offer: isOffer }, function() {
                if (isOffer) {
                    $('[data-action="add-to-basket"]', $roomContainer).attr('data-offer', true);
                }
            });
        });
    };

    return {
        render: render,
        setRoomsDependancy: function(module) {
            rooms = module;
        }
    };
});